module.exports = __webpack_public_path__ + "img/liczba_ofiar.e90fa896.svg";